import { Config } from "../../../configurations/config";

export const TimesheetPerformanceReport_APIs = {
	GetEmployeeList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
	GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
	GetStatusTypes: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetStatusTypes`,
	GetPerformanceReport: `${Config.server_url}${Config.api_prefix}/TimeSheet/PerformanceReport`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/TimeSheet/PerformanceReport/ExportToExcel`,
};
